// import { useEffect } from "react";
// import { Link } from "react-router-dom";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   Wifi,
//   Shield,
//   ChevronDown,
//   Server,
//   Cpu,
//   Code,
//   Network,
//   Laptop,
//   Database,
//   Lock,
//   Globe,
//   Activity,
//   Layers,
//   Terminal,
// } from "lucide-react";

// const IMAGES = {
//   hero: "https://djgeqya1wekbj.cloudfront.net/product-images/600-600/Cisco-CCNA-200-301-Online-1200x600.jpg.webp",
//   lab: "https://www.alphaacademy.org/wp-content/uploads/2024/08/CCNA-Networking-Essentials-A-Comprehensive-Cisco-Course_11zon.jpg",
//   router:
//     "https://t3.ftcdn.net/jpg/03/91/09/96/360_F_391099633_AVfJ35c2qE7NcVOjtN44Q68l1UnG79R8.jpg",
// };

// export default function CCNA() {
//   useEffect(() => {
//     AOS.init({ duration: 800, once: false, offset: 100 });
//     AOS.refresh();
//     window.scrollTo(0, 0);
//   }, []);

//   const syllabus = [
//     {
//       title: "Networking Fundamentals & OSI Model",
//       icon: Network,
//       desc: "Learn the foundation of computer networks and how communication works across layers.",
//     },
//     {
//       title: "IP Addressing, Subnetting, and VLANs",
//       icon: Laptop,
//       desc: "Understand IP addressing, subnetting, and segmentation using VLANs.",
//     },
//     {
//       title: "Routing Protocols (RIP, OSPF, EIGRP, BGP basics)",
//       icon: Activity,
//       desc: "Configure and troubleshoot routing protocols for efficient communication.",
//     },
//     {
//       title: "Switching Concepts & STP",
//       icon: Layers,
//       desc: "Master switching, VLAN trunking, and Spanning Tree Protocol.",
//     },
//     {
//       title: "Access Control Lists (ACLs) & NAT",
//       icon: Lock,
//       desc: "Control network access and secure IP traffic with ACLs and NAT.",
//     },
//     {
//       title: "WAN Technologies & VPNs",
//       icon: Globe,
//       desc: "Get familiar with wide-area networking concepts and VPN setup.",
//     },
//     {
//       title: "Network Security Fundamentals",
//       icon: Shield,
//       desc: "Learn security essentials for protecting your network infrastructure.",
//     },
//     {
//       title: "Automation & Cisco Packet Tracer Labs",
//       icon: Terminal,
//       desc: "Practice automation scripts and real-world labs using Cisco tools.",
//     },
//   ];

//   const labs = [
//     {
//       title: "Cisco Packet Tracer Labs",
//       desc: "Simulate routers, switches, and networks using Cisco’s official tool.",
//       icon: Cpu,
//     },
//     {
//       title: "Subnetting & IP Addressing",
//       desc: "Hands-on practice with IP design and subnetting real-world networks.",
//       icon: Database,
//     },
//     {
//       title: "Routing & Switching Lab",
//       desc: "Configure routers, VLANs, trunking, and inter-VLAN routing.",
//       icon: Code,
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-900">
//       {/* Hero */}
//       <section className="relative grid place-items-center overflow-hidden bg-gradient-to-b from-blue-700 to-cyan-600 text-white py-24">
//         <img
//           src={IMAGES.hero}
//           alt="CCNA"
//           className="absolute inset-0 h-full w-full object-cover opacity-25"
//         />
//         <div className="relative z-10 max-w-6xl px-6 text-center">
//           <h1
//             data-aos="zoom-in-down"
//             className="mt-6 text-4xl sm:text-5xl font-extrabold"
//           >
//             Cisco Certified Network Associate (CCNA)
//           </h1>
//           <p
//             data-aos="fade-zoom-in"
//             data-aos-delay="300"
//             className="mt-4 mx-auto max-w-2xl text-white/90"
//           >
//             Master Cisco networking concepts, routing & switching, IP services,
//             and security essentials to launch your networking career.
//           </p>
//           <div
//             data-aos="flip-up"
//             data-aos-delay="600"
//             className="mt-8 flex items-center justify-center gap-4"
//           >
//             <Link
//               to="/contact"
//               className="rounded-2xl bg-white px-6 py-3 font-semibold text-blue-700 shadow hover:scale-[1.02] transition"
//             >
//               Enroll Now
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Why CCNA */}
//       <section className="mx-auto max-w-6xl px-6 py-12">
//         <div className="grid gap-8 md:grid-cols-2 items-center">
//           <div data-aos="slide-right">
//             <h2 className="text-3xl font-bold">Why CCNA?</h2>
//             <p className="mt-4 text-slate-600">
//               CCNA is the gold standard for networking certifications. It proves
//               your ability to install, configure, operate, and troubleshoot
//               medium-sized routed and switched networks.
//             </p>
//             <ul className="mt-6 space-y-3">
//               <li
//                 className="flex items-center gap-3"
//                 data-aos="flip-left"
//                 data-aos-delay="200"
//               >
//                 <Shield
//                   className="text-blue-600 h-6 w-6 flex-shrink-0 transform transition-transform duration-500 hover:scale-125"
//                   data-aos="zoom-in"
//                   data-aos-delay="250"
//                 />
//                 <span>Industry-recognized certification</span>
//               </li>
//               <li
//                 className="flex items-center gap-3"
//                 data-aos="flip-left"
//                 data-aos-delay="400"
//               >
//                 <Wifi
//                   className="text-blue-600 h-6 w-6 flex-shrink-0 transform transition-transform duration-500 hover:scale-125"
//                   data-aos="zoom-in"
//                   data-aos-delay="450"
//                 />
//                 <span>Hands-on networking experience</span>
//               </li>
//               <li
//                 className="flex items-center gap-3"
//                 data-aos="flip-left"
//                 data-aos-delay="600"
//               >
//                 <Server
//                   className="text-blue-600 h-6 w-6 flex-shrink-0 transform transition-transform duration-500 hover:scale-125"
//                   data-aos="zoom-in"
//                   data-aos-delay="650"
//                 />
//                 <span>Strong foundation for CCNP & advanced IT careers</span>
//               </li>
//             </ul>
//           </div>
//           <div data-aos="slide-left">
//             <img
//               src={IMAGES.router}
//               alt="Router"
//               className="rounded-2xl shadow-lg object-cover w-full h-80"
//             />
//           </div>
//         </div>
//       </section>

//       {/* Course Curriculum */}
//       <section className="mx-auto max-w-6xl px-6 py-12">
//         <h3 className="text-2xl font-bold text-center" data-aos="zoom-in">
//           Course Curriculum
//         </h3>
//         <ul className="mt-8 grid gap-6 md:grid-cols-2 overflow-visible">
//           {syllabus.map((item, i) => (
//             <li
//               key={i}
//               className="flex items-start gap-4 rounded-lg bg-blue-50 p-4 shadow-lg ring-1 ring-slate-200
//                          hover:shadow-blue-300 transition-transform hover:scale-[1.02] max-w-md mx-auto"
//               data-aos="fade-up"
//               data-aos-delay={i * 120}
//             >
//               <item.icon
//                 className="h-8 w-8 text-blue-600 flex-shrink-0 transform transition-transform duration-500 hover:scale-125"
//                 data-aos="zoom-in"
//                 data-aos-delay={i * 150}
//               />
//               <div>
//                 <div className="font-semibold">{item.title}</div>
//                 <p className="text-sm text-slate-600">{item.desc}</p>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </section>

//       {/* Practical Labs */}
//       <section className="mx-auto max-w-6xl px-6 py-12">
//         <h3 className="text-2xl font-bold text-center" data-aos="zoom-in">
//           Practical Labs
//         </h3>

//         <div className="mt-10 grid gap-8 md:grid-cols-2 items-center">
//           {/* Lab Cards */}
//           <div className="space-y-4">
//             {labs.map((lab, i) => (
//               <div
//                 key={i}
//                 className="flex items-start gap-4 rounded-lg bg-cyan-50 p-4 shadow-lg ring-1 ring-slate-200
//                            hover:shadow-cyan-300 transition-transform hover:scale-[1.02]"
//                 data-aos="flip-right"
//                 data-aos-delay={i * 200}
//               >
//                 <lab.icon
//                   className="h-8 w-8 text-cyan-600 flex-shrink-0 transform transition-transform duration-500 hover:scale-125"
//                   data-aos="zoom-in"
//                   data-aos-delay={i * 250}
//                 />
//                 <div>
//                   <div className="font-semibold">{lab.title}</div>
//                   <div className="text-sm text-slate-600">{lab.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Lab Image */}
//           <div data-aos="fade-left" className="flex justify-center">
//             <img
//               src={IMAGES.lab}
//               alt="Lab"
//               className="rounded-2xl shadow-lg object-cover w-full h-80"
//             />
//           </div>
//         </div>
//       </section>

//       {/* FAQ */}
//       <section className="bg-white py-12">
//         <div className="mx-auto max-w-6xl px-6">
//           <h3
//             className="text-2xl font-bold text-center mb-6"
//             data-aos="flip-down"
//             data-aos-delay="100"
//           >
//             Frequently Asked Questions
//           </h3>
//           <div className="mt-4 space-y-3">
//             <details
//               className="group rounded-lg border p-4 bg-indigo-50 shadow hover:shadow-indigo-200 transition"
//               data-aos="fade-up"
//               open
//             >
//               <summary className="flex cursor-pointer items-center justify-between font-medium transition group-open:text-indigo-700">
//                 Do I need prior networking knowledge?{" "}
//                 <ChevronDown className="h-4 w-4 transition-transform duration-300 transform group-open:rotate-180 group-hover:scale-125" />
//               </summary>
//               <p className="mt-2 text-sm text-slate-600">
//                 Basic computer literacy is enough. We start from fundamentals
//                 before diving into advanced networking concepts.
//               </p>
//             </details>

//             <details
//               className="group rounded-lg border p-4 bg-indigo-50 shadow hover:shadow-indigo-200 transition"
//               data-aos="fade-up"
//               data-aos-delay="200"
//             >
//               <summary className="flex cursor-pointer items-center justify-between font-medium transition group-open:text-indigo-700">
//                 Will this prepare me for the CCNA exam?{" "}
//                 <ChevronDown className="h-4 w-4 transition-transform group-open:rotate-180 group-hover:scale-125" />
//               </summary>
//               <p className="mt-2 text-sm text-slate-600">
//                 Yes — our course covers all CCNA exam objectives with theory and
//                 labs. We also provide mock tests and exam prep.
//               </p>
//             </details>

//             <details
//               className="group rounded-lg border p-4 bg-indigo-50 shadow hover:shadow-indigo-200 transition"
//               data-aos="fade-up"
//               data-aos-delay="400"
//             >
//               <summary className="flex cursor-pointer items-center justify-between font-medium transition group-open:text-indigo-700">
//                 Is it hands-on or just theory?{" "}
//                 <ChevronDown className="h-4 w-4 transition-transform group-open:rotate-180 group-hover:scale-125" />
//               </summary>
//               <p className="mt-2 text-sm text-slate-600">
//                 The program is practical-first with Cisco Packet Tracer and real
//                 networking scenarios to build confidence.
//               </p>
//             </details>
//           </div>
//         </div>
//       </section>

//       {/* Bottom Enroll Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-12">
//         <div className="mx-auto max-w-4xl px-6 text-center" data-aos="zoom-in">
//           <h3 className="text-3xl font-bold mb-4">
//             Ready to Start Your Networking Journey?
//           </h3>
//           <p className="mb-6 text-lg">
//             Enroll in our CCNA course today and gain hands-on experience with
//             real-world labs, automation, and exam preparation.
//           </p>
//           <Link
//             to="/contact"
//             className="inline-block rounded-2xl bg-white text-blue-700 font-semibold px-8 py-4 shadow-lg hover:scale-105 transition-transform"
//           >
//             Enroll Now
//           </Link>
//         </div>
//       </section>
//     </div>
//   );
// }

import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Wifi,
  Shield,
  ChevronDown,
  Server,
  Cpu,
  Code,
  Network,
  Laptop,
  Database,
  Lock,
  Globe,
  Activity,
  Layers,
  Terminal,
} from "lucide-react";

const IMAGES = {
  hero: "/assets/832521b50654458c12d0536fdcfe4436.jpg",
  lab: "/assets/CCNA-Networking-Essentials-A-Comprehensive-Cisco-Course_11zon.jpg",
  router:
    "/assets/360_F_391099633_AVfJ35c2qE7NcVOjtN44Q68l1UnG79R8.jpg",
};

export default function CCNA() {
  useEffect(() => {
    AOS.init({ duration: 800, once: false, offset: 100 });
    AOS.refresh();
    window.scrollTo(0, 0);
  }, []);

  const syllabus = [
    {
      title: "Networking Fundamentals & OSI Model",
      icon: Network,
      desc: "Learn the foundation of computer networks and how communication works across layers.",
    },
    {
      title: "IP Addressing, Subnetting, and VLANs",
      icon: Laptop,
      desc: "Understand IP addressing, subnetting, and segmentation using VLANs.",
    },
    {
      title: "Routing Protocols (RIP, OSPF, EIGRP, BGP basics)",
      icon: Activity,
      desc: "Configure and troubleshoot routing protocols for efficient communication.",
    },
    {
      title: "Switching Concepts & STP",
      icon: Layers,
      desc: "Master switching, VLAN trunking, and Spanning Tree Protocol.",
    },
    {
      title: "Access Control Lists (ACLs) & NAT",
      icon: Lock,
      desc: "Control network access and secure IP traffic with ACLs and NAT.",
    },
    {
      title: "WAN Technologies & VPNs",
      icon: Globe,
      desc: "Get familiar with wide-area networking concepts and VPN setup.",
    },
    {
      title: "Network Security Fundamentals",
      icon: Shield,
      desc: "Learn security essentials for protecting your network infrastructure.",
    },
    {
      title: "Automation & Cisco Packet Tracer Labs",
      icon: Terminal,
      desc: "Practice automation scripts and real-world labs using Cisco tools.",
    },
  ];

  const labs = [
    {
      title: "Cisco Packet Tracer Labs",
      desc: "Simulate routers, switches, and networks using Cisco’s official tool.",
      icon: Cpu,
    },
    {
      title: "Subnetting & IP Addressing",
      desc: "Hands-on practice with IP design and subnetting real-world networks.",
      icon: Database,
    },
    {
      title: "Routing & Switching Lab",
      desc: "Configure routers, VLANs, trunking, and inter-VLAN routing.",
      icon: Code,
    },
  ];

  // Animation classes for icons
  const animations = [
    "animate-bounce",
    "animate-pulse",
    "animate-shake",
    "animate-spin-slow",
    "animate-jump",
    "animate-bounce",
    "animate-shake",
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 overflow-hidden">
      {/* Hero */}
      <section className="relative grid place-items-center overflow-hidden  text-white py-24">
        <img
          src={IMAGES.hero}
          alt="CCNA"
          className="absolute inset-0 h-full w-full object-cover "
        />
        <div className="relative z-10 max-w-6xl px-6 text-center">
          <h1
            data-aos="zoom-in-down"
            className="mt-6 text-4xl sm:text-5xl font-extrabold"
          >
            Cisco Certified Network Associate (CCNA)
          </h1>
          <p
            data-aos="fade-zoom-in"
            data-aos-delay="300"
            className="mt-4 mx-auto text-lg md:text-xl text-white/90"
          >
            Master Cisco networking concepts, routing & switching, IP services,
            and security essentials to launch your networking career.
          </p>
          <div
            data-aos="flip-up"
            data-aos-delay="600"
            className="mt-8 flex items-center justify-center gap-4"
          >
            <Link
              to="/contact"
              className="rounded-2xl bg-white px-6 py-3 font-semibold text-blue-700 shadow hover:scale-[1.02] transition animate-bounce"
            >
              Enroll Now
            </Link>
          </div>
        </div>
      </section>

      {/* Course Curriculum */}
      <section className="mx-auto max-w-6xl px-6 py-12">
        <h3 className="text-2xl font-bold text-center" data-aos="zoom-in">
          Course Curriculum
        </h3>
        <ul className="mt-8 grid gap-6 md:grid-cols-2 overflow-visible">
          {syllabus.map((item, i) => (
            <li
              key={i}
              className="flex items-start gap-4 rounded-lg bg-blue-50 p-4 shadow-lg ring-1 ring-slate-200 
                         hover:shadow-blue-300 transition-transform hover:scale-[1.02] max-w-md mx-auto"
              data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
              data-aos-delay={i * 120}
            >
              <item.icon
                className={`h-8 w-8 text-blue-600 flex-shrink-0 transform transition-transform duration-500 hover:scale-125 ${
                  animations[i % animations.length]
                }`}
              />
              <div>
                <div className="font-semibold">{item.title}</div>
                <p className="text-sm text-slate-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </section>

      {/* Practical Labs */}
      <section className="mx-auto max-w-6xl px-6 py-12">
        <h3 className="text-2xl font-bold text-center" data-aos="zoom-in">
          Practical Labs
        </h3>

        <div className="mt-10 grid gap-8 md:grid-cols-2 items-center">
          <div className="space-y-4">
            {labs.map((lab, i) => (
              <div
                key={i}
                className="flex items-start gap-4 rounded-lg bg-cyan-50 p-4 shadow-lg ring-1 ring-slate-200 
                           hover:shadow-cyan-300 transition-transform hover:scale-[1.02]"
                data-aos="flip-right"
                data-aos-delay={i * 200}
              >
                <lab.icon
                  className={`h-8 w-8 text-cyan-600 flex-shrink-0 transform transition-transform duration-500 hover:scale-125 ${
                    animations[i % animations.length]
                  }`}
                />
                <div>
                  <div className="font-semibold">{lab.title}</div>
                  <div className="text-sm text-slate-600">{lab.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Lab Image */}
          <div data-aos="fade-left" className="flex justify-center">
            <img
              src={IMAGES.lab}
              alt="Lab"
              className="rounded-2xl shadow-lg object-cover w-full h-80"
            />
          </div>
        </div>
      </section>

      {/* Bottom Enroll Section */}
      <section className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-12">
        <div className="mx-auto max-w-4xl px-6 text-center" data-aos="zoom-in">
          <h3 className="text-3xl font-bold mb-4">
            Ready to Start Your Networking Journey?
          </h3>
          <p className="mb-6 text-lg">
            Enroll in our CCNA course today and gain hands-on experience with
            real-world labs, automation, and exam preparation.
          </p>
          <Link
            to="/contact"
            className="inline-block rounded-2xl bg-white text-blue-700 font-semibold px-8 py-4 shadow-lg hover:scale-105 transition-transform animate-pulse"
          >
            Enroll Now
          </Link>
        </div>
      </section>
    </div>
  );
}
